import { SparklesIcon } from '@heroicons/react/16/solid';
import type { Editor } from '@tiptap/react';

import { Button } from '@oysterjs/ui/button';

type AddCaraSectionButtonProps = {
  editor: Editor;
};

/** The template editor's Add Cara section button. */
export const AddCaraSectionButton = ({ editor }: AddCaraSectionButtonProps) => (
  <div className="flex flex-wrap items-center gap-2 border-t border-neutral-200 px-2 py-1.5 dark:border-neutral-700">
    <Button color="white" onClick={() => editor.chain().focus().insertCaraSection().run()}>
      <SparklesIcon data-slot="icon" />
      Add Cara section
    </Button>
  </div>
);
